import styled from 'styled-components';

export const Container = styled.main`
  width: 100%;
  min-height: 94px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  justify-content: center;
  align-items: flex-start;
  padding: 12px 16px 18px 16px;
  border-radius: 4px;
  position: relative;
  cursor: pointer;

  background-color: ${(props) => props.isActive || props.isCompleted ? props.theme.colors.activeMenuBackgroundColor : props.theme.colors.component};
  border: 1px solid ${(props) => props.isActive || props.isCompleted ? 'transparent' : props.theme.colors.primary};
  color: ${(props) => props.theme.colors.modalTitleColor};

  h1 {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 16px;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: ${(props) => props.isActive ? props.theme.colors.cartTitleColor : props.theme.collapsibleList.titleColorUnBolded};
  }

  p {
    height: 26px;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;

    color: ${(props) => props.isActive ? props.theme.colors.text.default : props.theme.collapsibleList.titleColorUnBolded};
  }

  .activeTriangle {
    position: absolute;
    bottom: -4px;
    right: 22px;
    width: 0; 
    height: 0; 
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 18px solid ${(props) => props.theme.colors.component};
  }
`;

export const Tag = styled.span`
  position: absolute;
  top: 12px;
  right: 12px;
  border: 1px solid ${(props) => props.theme.colors.primary};
  border-radius: 6px;
  padding: 3px 6px 1px 6px;

  font-weight: 400;
  font-size: 9px;
  line-height: 11px;
`

export const Line = styled.span`
  display: block;
  width: 101px;
  height: 1px;
  background-color: ${(props) => props.isActive ? props.theme.colors.cartTitleColor : props.theme.collapsibleList.titleColorUnBolded};
  margin: 10px 0;
`
